// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + ({"327":"AccountAdmin","371":"Provider"}[chunkId] || chunkId) + "." + {"327":"59492d20","371":"59492d20","532":"60c4949c"}[chunkId] + ".chunk.css";
};